import styled from 'styled-components';

export const Text = styled.label `
    font-size: 14px;
    font-style: italic;
`;

export const Text2 = styled.label `
    font-size: 12px;
    font-style: italic;
    color: #555555;
`;

export const Text3 = styled.label `
    font-size: 12px;
    font-style: italic;
    color: white;
    background-color: #1351b4;
    cursor: pointer;
    border-radius: 100em;
    padding: 5px 10px;
    text-align: center;
`;

export const HeaderUp = styled.div `
    position: relative;
    top: 0px;
    width: 100%;

    #UserInfo {
        display: ${ props => props.showInfo ? '' : 'none'};
    }
    
    @media print {
        div {
            display: none;
        }        
    }
`;

export const MenuContainer = styled.div `
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    background-color: #fff;
    user-select: none;   /* Impede seleção */
    -webkit-user-select: none; /* Para Safari */
    -moz-user-select: none;    /* Para Firefox */
    background-color: #000287;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
    @media print {
            display: none;       
    }

    /* Barra superior */
    .navbar {
      display: ${ props => props.showInfo ? 'flex' : 'none'};
      justify-content: space-between;
      align-items: center;
      padding: 5px 20px;    
      max-width: 1520px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 40px;
      padding-right: 40px;
    }

    .navbar-item {
      display: flex;
      align-items: center;
      position: relative;
    }

    .navbar-item i {
      margin-right: 5px;
    }

    .navbar-item span {
      cursor: pointer;
      color: white;
      text-decoration: none;
      padding: 10px 10px;
      font-weight: bold;
    }

    .navbar-item span:hover {
      background-color: #25278f;
      border-radius: 5px;
    }

    /* Dropdown */
    .dropdown {
      position: relative;
      display: inline-block;
    }

    .dropdown-content {
      display: none;
      position: absolute;
      background-color: #f9f9f9;
      min-width: 250px;
      box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
      z-index: 1;
    }

    .dropdown-content span {
      color: #0c326f;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      font-size: 14px;
    }

    .dropdown-content span:hover {
      background-color: #25278f;
      color: #f9f9f9;
    }

    .dropdown:hover .dropdown-content {
      display: block;
    }
`;